import {Component, Input, OnInit, ElementRef, HostListener, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import {OpenClassConfig} from '../openClass-config/openClass-config';
import {PlatformLocation} from '@angular/common';

declare var Hammer: any;
declare var $: any;

@Component({
  selector: 'app-ability-survey',
  templateUrl: './ability-survey.component.html',
  styleUrls: ['./ability-survey.component.css', './new-guide-card.css']
})

export class AbilitySurveyComponent implements OnInit, AfterViewInit {
	@HostListener('window:popstate', ['$event']) onPopState(){
    	this.removeRemainTime();
    }
  isDataLoad = false;
	//考核内容
	surveyInfo: any;
	//考核基本内容
	surveyBaseInfo: any;
	//考核标题
	title = '';
	//剩余时间
	remainTime = 0;
	//题目列表
	questionsList: any = [];
	//显示进入标题文字
	showEnterTxt = false;
	//显示介绍
	showIntroduce = true;
	//是否已经进入题库
	enterEnable = false;
	//是否继续做题提示
	continueTipEnable = false;
	//是否退出提示
	exitTipEnable = false;
	//题目总数量
	qstCount = 0;
	//选项名称
	letterList: any = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
	//当前场景提示
	currentSceneTip: any;
	//是否显示tIP
	showsceneTipEnable = false;
	//回顾场景按钮是否可点击
	showsceneBtnEnable = true;
	//显示滑动提示
	showSwiptipEable = true;
	//是否停止指示动画
	stopArrowAnimate = false;
	//是否显示指示动画
	showArrowEnable = true;
	//滑动对象
	hammertime: any;
	//转向判断是否完成
	judgeFinish = false;
	//前端计时obj
	intervalId: any;
	//本地延时时间
	localRemainTimes = 0;
	//本地延时key
	localRemainTimesKey = '';
	//参数
	learningPathId = 0;
  learningPathMetaId: any;
	typeId = 0;
  isOpenClass = 0;
  isPC = false;
	isSelectedGood = false;
	isSelectedBad = false;
	isPreTestFinished = true;
  openClassConfig: OpenClassConfig;
  assetsRoute = '../../assets';
  examId: any;
  showPCBtn = false;
  isClicked = true;
  moduleId = 0;
  projectId: string;

  //控制新旧引导页面
  oldGuidePage = false;
  abilityName: string;
  // Stephen add 2025-03-07 判断是否腾讯对接
  isTencent: boolean = false;
	constructor(
		private commonService: CommonService,
		private apiService: ApiService,
		private route: ActivatedRoute,
    private router: Router,
    private platformLocation: PlatformLocation,
		private el: ElementRef) {
	}

	ngOnInit() {
    // ---Stephen add 2025-03-07---
    // 添加是否腾讯对接的判断
    this.isTencent = this.commonService.checkAndSetModuleId();
    console.log(this.isTencent, '🚀🚀🚀🚀🚀🚀🚀🚀🚀')
    // -------------------------------------------------------------------
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
	  this.openClassConfig = new OpenClassConfig(this.apiService);
		this.route.params.subscribe(params => {
		    this.learningPathId = params['learningPathId'];
		    this.typeId = params['typeId'];
		    if (this.typeId == 1){
		    	this.title = '能力诊断';
				 this.moduleId = 1;
          localStorage.setItem('moduleId', '1');
		    }else{
		      console.log(this.learningPathId);
		    	this.title = '能力考核';
				 this.moduleId = 4;
          localStorage.setItem('moduleId', '4');

          this.openClassConfig.getPostSurvey(this.learningPathId).subscribe(result => {
            this.isPreTestFinished = result.finishFlag;
            this.examId = result.examId;
          });
		    }
      //增加学习断点
      this.commonService.addUserBreakPoint({'learningPathMetasId': Number(this.learningPathId), 'moduleId': this.moduleId, 'breakpointUrl': this.platformLocation['location']['href'], 'projectId': localStorage.getItem('projectId') ? localStorage.getItem('projectId') : null}).then();
		});
		this.projectId = localStorage.getItem('projectId');
    this.isOpenClass = Number(localStorage.getItem('openClass')) ? 1 : 0;
    this.isPC = localStorage.getItem('isPC') ? true : false;
    this.showPCBtn = this.isPC;

		this.checkSurveyInfo().subscribe(resultBase => {
		  if (resultBase){
        this.surveyBaseInfo = resultBase;
        //完成转向报告
        if (this.surveyBaseInfo.finishFlag){
          this.goReport();
        }else if (this.surveyBaseInfo.startFlag){
          this.continueTipEnable = true;
          this.judgeFinish = true;
        }else{
          this.getSurveyInfoBase();
          this.judgeFinish = true;
        }
      }
    });
    //调取learningPath接口
    const learningPathMetaId = this.learningPathId; //参数有误，纠正
    this.apiService.getOrCreateLearningPath(String(learningPathMetaId)).subscribe(item => {
      this.abilityName = item.name;
    });
  }

  // learning
	ngAfterViewInit() {
		this.commonService.initPage();

    const interval = setInterval(() => {
      if (this.findDom('#abilitySurveyWrap')){
        clearInterval(interval);
        this.pageStart();
      }
    }, 100);
	}


	checkPreTestFinished(learningPathMetaId){
	  return this.apiService.ajax({
      'type': 'get',
      'url': 'sr/survey/getSurvey/' + learningPathMetaId + '/1'
    });
  }

	findDom(dom){
	  let flag = false;
	  if ($(this.el.nativeElement).find(dom)[0]){
      flag = true;
    }
    return flag;
  }

	//事件初始化
	pageStart(){
		const that = this;
		const domObject = $(this.el.nativeElement).find('#abilitySurveyWrap')[0];

		if (!this.isPC){
      that.hammertime = new Hammer(domObject);
      that.hammertime.get('pan').set({
        direction: Hammer.DIRECTION_ALL
      });
      that.hammertime.on('pan', function(ev){
        //向上解锁
        if (ev.deltaY < 0){
          const currentLI = $('#questionItem .current');
          currentLI.css('margin-top', ev.deltaY);
          that.showEnterTxt = true;
        }
      });

      that.hammertime.on('panend pancancel', function(ev){
        const currentLI = $('#questionItem .current');
        if (ev.deltaY > -100){
          currentLI.css('margin-top', 0);
        }else{
          currentLI.css('margin-top', '-100%');
          that.startQuestion();
          that.getNextQuestion();
        }
        that.showEnterTxt = false;
      });
    }
	}

  goNext(){
    const currentLI = $('#questionItem .current');
    currentLI.css('margin-top', '-100%');
    this.startQuestion();
    this.getNextQuestion();
    this.showPCBtn = false;
  }


	/* 开始做题 */
	startQuestion(){
	  this.commonService.learningPortEventLogByCandy({'learningPathMetaId': this.learningPathId, 'module': this.title + '场景一的情景模拟描述页面', 'userId': localStorage.getItem('userId')}).then();
		const that = this;
		if (!that.isPC){
      //进入题目
      that.showsceneBtnEnable = false;
      that.hammertime.get('pan').set({ enable: false });
      //开启做题模式
      setTimeout(() => {
        that.hammertime.get('swipe').set({
          direction: Hammer.DIRECTION_ALL
        });
        that.hammertime.on('swipeup swipedown', function(ev){
          that.catchEvent(ev, that);
        });
        that.showIntroduce = false;
        that.enterEnable = true;

        that.setRemainTime();
      }, 300);
    }else{
      that.showsceneBtnEnable = false;
      setTimeout(() => {
        that.showIntroduce = false;
        that.enterEnable = true;

        that.setRemainTime();
      }, 300);
    }
	}
	swipeEnable = true;
	/*上下滑动事件,整体流程控制 */
	catchEvent(ev, that){
		if (!that.swipeEnable){
			return false;
		}
		// 如果点击的是选项区域，不处理swipe事件
		const target = ev.srcEvent ? ev.srcEvent.target : (ev.target || null);
		if (target){
			// 检查是否点击在选项区域内
			let element = target;
			while (element && element !== document.body){
				if (element.classList && (
					element.classList.contains('effectiveOption') || 
					element.classList.contains('invalidOption') || 
					element.classList.contains('option-item') ||
					element.classList.contains('answer-conver')
				)){
					return false;
				}
				element = element.parentElement;
			}
		}
		that.swipeEnable = false;
		setTimeout(() => {
			that.swipeEnable = true;
		}, 300);

		//向上
		if (ev.type == 'swipeup'){
        that.getNextQuestion();
		}
		//向下
		if (ev.type == 'swipedown'){
        that.getPreQuestion();
		}
	}
	close(){
		this.exitTipEnable = true;
	}

	preQA(index){
	  if (index !== 1){
      this.getPreQuestion();
    }
  }

  nextQA(index){
	  if (index == this.qstCount){
	    this.saveSurveyInfo(1);
    }else{
      this.getNextQuestion();
    }
  }

  doExercises(){
    this.getNextQuestion();
  }
	/* 初始化考核详细  */
	surveyInit(){
		//计时
		this.remainTime = this.surveyInfo.totalTime;
		if (this.remainTime <= 0){
			this.saveSurveyInfo(2);
			return false;
		}
		//将问题合并
		this.questionsList = []; //清空数据
		this.surveyInfo.surveyScenes.forEach((item, i) => {
			this.questionsList.push({
				type: 'scene',
				sceneTitle: item.sceneTitle,
				sceneDesc: item.sceneDesc,
				sceneId: item.sceneId,
				completeFlag: true,
				sceneIndex: i
			});
			this.surveyQuestionInit(item.surveySceneQuestions, item.sceneId, i);
		});
	}


	/* 数据本地计时 */
	getRemainTimeFromlocal(){
		let remainTimes = 0;
		this.localRemainTimesKey = 'sueryremainTime' + this.learningPathId + this.typeId;

		const localRemainTimesObj =  localStorage.getItem(this.localRemainTimesKey);
		if (localRemainTimesObj && localRemainTimesObj != ''){
			remainTimes = parseInt(localRemainTimesObj);
		}
		return remainTimes;
	}

	//清除现有计时
	removeRemainTime(){
		if (this.intervalId){
	        clearInterval(this.intervalId);
	    }
	}

	//清除现有计时时间
	clearRemainTimes(){
		this.localRemainTimes = 0;
		this.localRemainTimesKey = 'sueryremainTime' + this.learningPathId + this.typeId;
		localStorage.setItem(this.localRemainTimesKey, this.localRemainTimes + '');
		localStorage.removeItem(this.localRemainTimesKey);
	}

	//本地计时
	setRemainTime(){
		this.localRemainTimesKey = 'sueryremainTime' + this.learningPathId + this.typeId;
		this.removeRemainTime();
		this.intervalId = setInterval(() => {
			this.localRemainTimes++;
			//console.log("计时:" + this.localRemainTimes);
			localStorage.setItem(this.localRemainTimesKey, this.localRemainTimes + '');
		}, 1000);
	}

	/* 初始化考核题目 */
	surveyQuestionInit(surveySceneQuestions, sceneId, sceneIndex){
		surveySceneQuestions.forEach((item) => {
			item.sceneId = sceneId;
			item.type = 'question';
			item.sceneIndex = sceneIndex;
			this.qstCount++;
			item.qstIndex = this.qstCount;
			this.questionsList.push(item);
		});
	}

	moveToCurrentQuestion(){
		this.startQuestion();
		let currentLI = $('#questionItem .finish.questionItem:last');
		//未做题时
		if (currentLI.length == 0){
			currentLI = $('#questionItem>li:first');
		}
		const nextObj = currentLI.next();
		$('#questionItem .current').removeClass('current');
		if (nextObj.length == 1){
			currentLI.addClass('pre');
			nextObj.addClass('current');
			nextObj.next().addClass('next');
			this.getCurrentSimulation(nextObj);
		}else{
			currentLI.prev().addClass('pre');
			currentLI.addClass('current');
			this.getCurrentSimulation(currentLI);
			//最后一题
			this.showArrowEnable = false;
		}
	}

	/* 继续下一题 */
	getNextQuestion(){
		const currentLI = $('#questionItem .current');
		const currentPre = $('#questionItem .pre');
		const currentNext = $('#questionItem .next');
		if (!currentLI.hasClass('finish')){
			return false;
		}
		const nextObj = currentLI.next();
		if (nextObj.length == 1){
			currentPre.removeClass('pre');
			currentNext.removeClass('next');
			currentLI.removeClass('current').addClass('pre');
			nextObj.addClass('current');
			nextObj.next().addClass('next');

			this.getCurrentSimulation(nextObj);
			//最后一题
			if (nextObj.next().length == 0){
				this.showArrowEnable = false;
			}
		}
	}

	/* 获取前一题  */
	getPreQuestion(){
		const currentLI = $('#questionItem .current');
		//答题时禁用 hammer
		if (currentLI.hasClass('showeffective') || currentLI.hasClass('showinvalid')){
			return false;
		}
		const currentPre = $('#questionItem .pre');
		const currentNext = $('#questionItem .next');
		//滑动至下一题
		const preObj = currentLI.prev();
		if (preObj.length == 1){
			currentPre.removeClass('pre');
			currentNext.removeClass('next');

			currentLI.removeClass('current').addClass('next');
			preObj.addClass('current');
			preObj.prev().addClass('pre');
			this.getCurrentSimulation(preObj);
			this.showArrowEnable = true;
		}
	}

	/* 获取当前考核情景  */
	getCurrentSimulation(currentLI){
      const simulationObj = currentLI.find('.simulationIndex');
      if (simulationObj.length > 0){
        const simulationIndex = parseInt(simulationObj.val());
        this.currentSceneTip = this.surveyInfo.surveyScenes[simulationIndex];
        this.currentSceneTip.index = simulationIndex;
        this.showsceneBtnEnable = true;
      }else{
        this.currentSceneTip = this.surveyInfo.surveyScenes[0];
        this.currentSceneTip.index = 0;
        this.showsceneBtnEnable = false;
      }

      //是否完成该题
      if (currentLI.hasClass('finish')){
        this.stopArrowAnimate = false;
      }else{
        this.stopArrowAnimate = true;
      }
	}

	/* 获取考核详情 API */
	getSurveyInfo(){
	  console.log(this.typeId);
		const reduceTime =  this.getRemainTimeFromlocal();
		return this.apiService.ajax({
    		'type': 'get',
	        'url': 'sr/survey/show/' + this.learningPathId + '/' + this.typeId + '/' + reduceTime
    	});
	}
	getSurveyInfoAjax(){
		this.getSurveyInfo().subscribe(result => {
		  	if (result.success){
				this.surveyInfo = result;
				this.isDataLoad = true;
				this.surveyInit();

				setTimeout(() => {
					this.moveToCurrentQuestion();
				}, 300);
			}
		});
	}

	getSurveyInfoBase(){
      // setTimeout(()=>{
      // this.surveyInfo = {"id":1152,"totalTime":1500,"surveyScenes":[{"sceneId":15,"sceneTitle":"最近你加入了新公司，领导要求你带领团队马上开始一个新项目。虽然以往也有带领类似项目的经验，但你对这个团队的情况并不熟悉。","sceneDesc":"说明：<br/>1.背景：后面的5道题目都发生在情景1下，是一个任务的计划与组织过程的不同阶段，题目之间具有连贯性。\n<br/>2.目标：完整地完成一个任务的计划与组织过程。","surveySceneQuestions":[{"questionsNo":91,"questionsName":"新的团队新的项目，面临着很多需要同时安排的任务，你有点不知所措。","completeFlag":false,"surveySceneOptions":[{"optionsNo":363,"optionsName":"预估一下各任务的难度，把能够上手做的做起来。"},{"optionsNo":362,"optionsName":"将核心任务分配给几个能力比较强的员工，让他们代你分配。"},{"optionsNo":361,"optionsName":"先对工作流程与系统进行评估，优先执行项目中最重要的任务。"},{"optionsNo":364,"optionsName":"让团队成员各自认领他们当前能够做的工作，分头行动。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":92,"questionsName":"对于新团队你并不十分熟悉，突然要安排下去很多任务，你担心团队能否了解你的要求。","completeFlag":false,"surveySceneOptions":[{"optionsNo":367,"optionsName":"为了公平起见，将新任务平均分配到每位团队成员。"},{"optionsNo":365,"optionsName":"与团队骨干讨论如何将项目拆解到个人，以及希望他们如何去做。"},{"optionsNo":366,"optionsName":"按照自己过去带项目的经验，为对应的岗位分配任务。"},{"optionsNo":368,"optionsName":"让骨干团队成员自由选择他们自己想做的任务，剩下的分给其他成员。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":93,"questionsName":"你发现以新团队的工作节奏，没办法在预估的期限内完成项目。","completeFlag":false,"surveySceneOptions":[{"optionsNo":369,"optionsName":"根据团队成员的工作效率为他们制定工作时间安排，评估是否和他们现有的工作安排有冲突。"},{"optionsNo":372,"optionsName":"后期如果时间来不及再申请延期。"},{"optionsNo":371,"optionsName":"强调这个项目很重要，让大家加速赶工完成。"},{"optionsNo":370,"optionsName":"根据团队成员每个月的工作重点，为他们制定月度工作计划。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":94,"questionsName":"团队目前的工作效率并不理想，但以你的经验来说人手是足够的。","completeFlag":false,"surveySceneOptions":[{"optionsNo":373,"optionsName":"让有经验的团队负责人帮忙审视目前的人员安排和工作流程，看哪些地方能够提升工作效率。"},{"optionsNo":376,"optionsName":"督促个别效率不高的员工，提醒他们不要做工作以外的事情。"},{"optionsNo":374,"optionsName":"寻求人力资源部门的帮助，提供有助于提升工作效率的培训。"},{"optionsNo":375,"optionsName":"工作效率的提升不是一两天的事情，先问问其他部门能否借调人手来支持。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":95,"questionsName":"你已经将任务详细地分配给团队成员，但对于团队的执行效果，还是没有什么把握。","completeFlag":false,"surveySceneOptions":[{"optionsNo":377,"optionsName":"在计划中制定好各阶段的详细目标，加大进度检查的频率。"},{"optionsNo":379,"optionsName":"告诉团队成员项目完成情况是KPI考核的主要指标，希望大家能够重视。"},{"optionsNo":378,"optionsName":"每周听取团队成员的工作进展汇报。"},{"optionsNo":380,"optionsName":"让团队成员在遇到意外状况或者解决不了的问题时，再来找你商量。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0}]},{"sceneId":16,"sceneTitle":"创新是今年公司的战略方向，为了更好地满足客户需求，你和另一个部门的负责人决定发起一个新项目，结合双方优势设计一个针对客户的新方案。","sceneDesc":"说明：<br/>1.背景：后面5道题目都发生在情景2下，是一个任务的计划与组织过程的不同阶段，题目之间具有连贯性。\n<br/>2.目标：完整地完成一个任务的计划与组织过程。","surveySceneQuestions":[{"questionsNo":96,"questionsName":"因为是第一次接手跨部门合作项目，双方对于要配合对方做些什么都不是太清楚。","completeFlag":false,"surveySceneOptions":[{"optionsNo":384,"optionsName":"新项目也不是非要在这段时间完成，优先处理自己团队的紧急工作。"},{"optionsNo":383,"optionsName":"两个部门各自手头都还有很多其他工作，先做立马能做的事。"},{"optionsNo":381,"optionsName":"邀请对方部门的业务骨干一起讨论设计新方案的步骤，突出那些需要重点攻克的地方。"},{"optionsNo":382,"optionsName":"让团队收集客户的资料，稍后再进行设计。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":97,"questionsName":"在此次合作之前，你并不了解对方部门能够提供哪些支持，现在你们需要将任务落实下去。","completeFlag":false,"surveySceneOptions":[{"optionsNo":386,"optionsName":"先草拟一份双方的任务分配，再找对方团队的负责人讨论。"},{"optionsNo":387,"optionsName":"先把自己团队能做的任务安排好，剩下的任务让对方团队挑选。"},{"optionsNo":388,"optionsName":"为了确保对方团队的投入度，先等对方团队发起方案的讨论。"},{"optionsNo":385,"optionsName":"两个部门一起开会分解任务，讨论双方需要提供的支持以及配合的时间。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":98,"questionsName":"接下来两个月是你们的业务旺季，会非常繁忙，可能无法配合完成这样的合作项目。","completeFlag":false,"surveySceneOptions":[{"optionsNo":390,"optionsName":"和对方部门负责人商量，前期能否先让他们部门多安排人员在这个项目上。"},{"optionsNo":392,"optionsName":"创新项目是证明团队能力的好机会，让大家加班加点也要完成。"},{"optionsNo":389,"optionsName":"在保证业务正常运转的情况下，制定时间表，抽调空余人员错峰支援新项目。"},{"optionsNo":391,"optionsName":"向领导申请等业务旺季过后再继续完成项目。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":99,"questionsName":"在设计创新方案的过程中，你发现团队内部对创新的形式有很大争议。","completeFlag":false,"surveySceneOptions":[{"optionsNo":394,"optionsName":"扩大讨论范围，看看其他人是如何评价的。"},{"optionsNo":393,"optionsName":"请教曾经做过创新项目的团队，有哪些有效的评判标准或建议可以借鉴。"},{"optionsNo":396,"optionsName":"作为团队负责人，你能够决定采用哪种创新形式。"},{"optionsNo":395,"optionsName":"让团队内部多出几个方案，都试一下。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0},{"questionsNo":100,"questionsName":"目前双方团队的任务已经分配下去了，但你对于实际的执行效果没什么把握。","completeFlag":false,"surveySceneOptions":[{"optionsNo":397,"optionsName":"与对方团队一起为各阶段的交付成果制定一个标准，并定期开会交流进度和遇到的困难。"},{"optionsNo":400,"optionsName":"双方只要按照各自的任务安排去完成，不出意外就行。"},{"optionsNo":399,"optionsName":"告诉团队遇到难以解决的问题时，及时向你反馈。"},{"optionsNo":398,"optionsName":"定期参加对方团队的相关会议，了解他们的工作进展。"}],"effectiveOptionsNo":0,"invalidOptionsNo":0}]}]};
      //   this.isDataLoad = true;
      //   this.surveyInit();
      // },1000);
		this.getSurveyInfo().subscribe(result => {
		  if (result.success){
        this.surveyInfo = result;
        this.isDataLoad = true;
        this.surveyInit();
      }
		});
	}

	/* 检测考核详情 */
	checkSurveyInfo(){
		return this.apiService.ajax({
    		'type': 'get',
	        'url': 'sr/survey/getSurvey/' + this.learningPathId + '/' + this.typeId
    	});
	}
	/* 重置考核详情 */
	resetSurveyInfo(){
		return this.apiService.ajax({
    		'type': 'post',
	        'url': 'sr/survey/reset/' + this.learningPathId + '/' + this.typeId
    	});
	}
	/* 保存单个题目 */
	saveSurveyQuestionInfo(qstItem){
		this.showSurQuestionInfo(qstItem);
		if (qstItem.effectiveOptionsNo == 0 || qstItem.invalidOptionsNo == 0){
			return false;
		}

		const postData = {
		  'effectiveOptionId': qstItem.effectiveOptionsNo,
		  'invalidOptionId': qstItem.invalidOptionsNo,
		  'questionId': qstItem.questionsNo
		};
		return this.apiService.ajax({
    		'type': 'post',
    		'data': postData,
	        'url': 'sr/survey/saveSurveyAnswer'
    	}).subscribe(result => {
    	  if (result.success){
          qstItem.completeFlag = true;
          this.stopArrowAnimate = false;
          this.clearRemainTimes();
          this.setRemainTime();
        }
    	});
	}
	//显示题目
	showSurQuestionInfo(qstItem){
		this.showsceneBtnEnable = true;
		qstItem.showEffective = false;
		qstItem.showInvalid = false;

		if (qstItem.qstIndex < this.qstCount){
			this.showArrowEnable = true;
		}
	}
	cancelEvent($event){
		$event.stopPropagation();
	}
	/* 保存考核 */
	saveSurveyInfo(submitType: number){
    if (this.isClicked){
      this.isClicked = false;
      return this.apiService.ajax({
        'type': 'post',
        'url': 'sr/survey/finish/' + this.learningPathId + '/' + this.typeId + '/' + submitType
      }).subscribe( result => {
        if (result.success){
          this.goReport();
        }
      });
    }else{
      return false;
    }
	}
	// 防止touchstart和click重复触发
	private lastTouchTime = 0;
	private lastTouchTarget: any = null;

	/* 选择有效先项  */
	saveEffectiveItem(qstItem, optionsNo, event?){
		if (event){
			// 防止touchstart和click重复触发
			const now = Date.now();
			const isTouch = event.type === 'touchstart';
			if (isTouch){
				this.lastTouchTime = now;
				this.lastTouchTarget = event.target;
			} else if (event.type === 'click'){
				// 如果300ms内有touchstart事件，忽略click事件
				if (now - this.lastTouchTime < 300 && this.lastTouchTarget === event.target){
					return;
				}
			}
			event.preventDefault();
			event.stopPropagation();
		}
		qstItem.effectiveOptionsNo = optionsNo;
		this.saveSurveyQuestionInfo(qstItem);
    this.isSelectedGood = true;
	}
	/* 选择无效先项  */
	saveInvalidItem(qstItem, optionsNo, event?){
		if (event){
			// 防止touchstart和click重复触发
			const now = Date.now();
			const isTouch = event.type === 'touchstart';
			if (isTouch){
				this.lastTouchTime = now;
				this.lastTouchTarget = event.target;
			} else if (event.type === 'click'){
				// 如果300ms内有touchstart事件，忽略click事件
				if (now - this.lastTouchTime < 300 && this.lastTouchTarget === event.target){
					return;
				}
			}
			event.preventDefault();
			event.stopPropagation();
		}
		qstItem.invalidOptionsNo = optionsNo;
		this.saveSurveyQuestionInfo(qstItem);
		this.isSelectedBad = true;
	}
	/* 显示选择选项 */
	showEffective(item, event?){
		if (event){
			// 防止touchstart和click重复触发
			const now = Date.now();
			const isTouch = event.type === 'touchstart';
			if (isTouch){
				this.lastTouchTime = now;
				this.lastTouchTarget = event.target;
			} else if (event.type === 'click'){
				// 如果300ms内有touchstart事件，忽略click事件
				if (now - this.lastTouchTime < 300 && this.lastTouchTarget === event.target){
					return;
				}
			}
			event.preventDefault();
			event.stopPropagation();
		}
		this.showsceneBtnEnable = false;
		this.showArrowEnable = false;
		item.showEffective = true;
	}
	/* 显示选择选项 */
	showInvalid(item, event?){
		if (event){
			// 防止touchstart和click重复触发
			const now = Date.now();
			const isTouch = event.type === 'touchstart';
			if (isTouch){
				this.lastTouchTime = now;
				this.lastTouchTarget = event.target;
			} else if (event.type === 'click'){
				// 如果300ms内有touchstart事件，忽略click事件
				if (now - this.lastTouchTime < 300 && this.lastTouchTarget === event.target){
					return;
				}
			}
			event.preventDefault();
			event.stopPropagation();
		}
		this.showsceneBtnEnable = false;
		this.showArrowEnable = false;
		item.showInvalid = true;
	}
	/* 显示场景对话框 */
	showSceneDialog(){
		this.showsceneTipEnable = true;
	}
	/* 关闭场景对话框 */
	closeSceneDialog(){
		this.showsceneTipEnable = false;
	}
	/* 提示框确认和取消事件 */
	continueSure(){
		this.continueTipEnable = false;
		this.resetSurveyInfo().subscribe(result => {
		  if (result.success){
        this.clearRemainTimes();
        this.getSurveyInfoAjax();
      }
		});
	}
	continueCancel(){
		this.continueTipEnable = false;
		this.getSurveyInfoAjax();
	}
	/* 移除滑动提示 */
	removeSwipTip(){
    this.commonService.learningPortEventLogByCandy({'learningPathMetaId': this.learningPathId, 'module': this.title + '第一道题的页面', 'userId': localStorage.getItem('userId')}).then();
		this.showSwiptipEable = false;
	}
	exitSure(){
		this.goLearningPath();
	}
	exitCancel(){
		this.exitTipEnable = false;
	}

	/* 超时提醒 */
	onTimeReminder() {
        $('#tip1').fadeIn(500);

        setTimeout(function () {
            $('#tip1').fadeOut(500);
        }, 2000);
    }

	onTimeout(){
		$('#tip2').fadeIn(500);
		setTimeout(() => {
      this.saveSurveyInfo(2);
    }, 3000);
	}

	goLearningPath(){
		this.removeRemainTime();
		// if(this.projectId && this.projectId.trim() != ''){
		// 	localStorage.removeItem("projectmsg")
		// 	let link = ['learning-project-path', this.learningPathId];
      //   	this.router.navigate(link,{
		// 		queryParams:{
		// 			projectId: this.projectId
		// 		}
		// 	});
		// }else{
			const link = ['learning-path', this.learningPathId];
        	this.router.navigate(link);
		// }

	}
	goReport(){
		this.removeRemainTime();
		this.clearRemainTimes();
		const link = ['ability-report-new', this.learningPathId, this.typeId];
     if (this.isTencent) {
       this.router.navigate(link,{queryParams:{moduleId:window.sessionStorage.getItem('txModuleId')}})
     } else {
       this.router.navigate(link);
     }

	  	//向LMS平台传递进度数据
		if (localStorage.getItem('source_env') === 'LMS_SCORM'){
			this.apiService.getUserQueryLearningProgress(Number(this.learningPathId)).subscribe(res => {
				this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', res[0].progressList[0].progress, 'data');
			});
			if (this.moduleId === 4){
				this.apiService.getUserQueryLearningProgress(Number(this.learningPathId)).subscribe(res => {
					this.commonService.sendDataMessage('type', 'LMS_LEARN_COMPLETED', true, 'data');
				});
			}
		}
	}

  goPreSurvey(){
    this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?' + `token=${localStorage.getItem('transtalen-token')}` + '&target_url=/ability-survey/' + this.learningPathId + '/1/#isShowBack=0';
    // let link = ['ability-survey', this.learningPathId, 1];
    // this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// ./src/app/ability-survey/ability-survey.component.ts